import { OrganisationsResponse } from '../../api-models';
import { OrganisationNames } from '../../types/core.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class GetOrganisations extends BaseAdapter<OrganisationsResponse> implements AdapterInterface {
  rawResponse: OrganisationsResponse;

  async adaptResponse(): Promise<OrganisationNames> {
    await this.fetchApiResponse('/api/organisations', HTTPMethod.Get);
    return {
      organisationNames: this.rawResponse.organisation_display_names,
    };
  }
}
